module.exports = __webpack_public_path__ + "img/cert-product-mob.445587c.webp";